// extracted by mini-css-extract-plugin
export default {"wrapper":"x3-z","play":"y3-z"};